import React from "react";
import PropTypes from "prop-types";
import { optimiseImage } from "src/common/utils/prismic-image";

const CharacterThumbnail = (props) => (
  <img
    className="character-thumbnail"
    src={optimiseImage(props.src)}
    alt={props.alt}
  />
);

CharacterThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default CharacterThumbnail;
